import { colorsPalettes, fonts } from "@similarweb/styles";
import { capitalizeFirstLetter } from "app/pages/sales-intelligence/common-components/styles";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledChip = styled(CenteredFlexRow).attrs<{ "data-automation"?: string }>(() => ({
    "data-automation": "signal-type-chip",
}))`
    height: 24px;
    padding: 0 8px;
    margin: 0;

    color: ${colorsPalettes.blue[400]};
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 40px;

    &:hover,
    &:active {
        cursor: pointer;
        color: ${colorsPalettes.blue[500]};
        background-color: ${colorsPalettes.blue[100]};
    }
`;

export const StyledChipText = styled.span`
    ${capitalizeFirstLetter};

    color: currentcolor;

    font-family: ${fonts.$dmSansFontFamily};
    font-size: 10px;
    font-weight: 500;
    line-height: 10px;
`;
